// Sayfa çözücülerin (istemci + SSR) ortak hata mesajı: yanlış bileşen adı sessizce
// boş sayfa üretmesin, hangi dosyanın arandığı ve nelerin mevcut olduğu yazsın.

export function pageNotFound(name: string, globKeys: string[]): never {
  const available = globKeys
    .map((key) => key.replace(/^.*\/pages\//, '').replace(/\.tsx$/, ''))
    .sort()
    .join(', ')

  throw new Error(
    `Public sayfası bulunamadı: "${name}" ` +
      `(aranan dosya: app/frontend/public/pages/${name}.tsx). Mevcut sayfalar: ${available}`,
  )
}
